import { render, staticRenderFns } from "./ContentsLayout.vue?vue&type=template&id=5b6eb25a&"
import script from "./ContentsLayout.vue?vue&type=script&lang=js&"
export * from "./ContentsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports